module.exports = __webpack_public_path__ + "img/message-square-02.63f10bc4.svg";